<template>
  <div>
    <div class="zjz_con">
      <div class="zjz_l">
        <div class="title">
          <img :src="$_c + 'img/jjz_img/btn_bg.svg'" />
          <span>包组栏</span>
        </div>
        <ul class="back-list">
          <li v-for="(item, index) in 1" :key="index" class="pack-title-active">
            <span>包组1</span>
          </li>
        </ul>
      </div>
      <div class="zjz_c">
        <div class="t1">
          <div>
            包组1：电脑采购（包组编号：COMPUTER-NO1）
            <a-button
              type="link"
              icon="search"
              size="small"
              style="color: #fffe00"
            >
              查看标的物
            </a-button>
          </div>
          <div>包组编号：514946116AD6DSCCS</div>
        </div>
        <div style="height: 9.083vw">
          <div class="t2" v-if="status === '1'">
            <span>{{ prefix }}</span>
            <span class="box" v-if="day">{{ day }}</span>
            <span v-if="day">天</span>
            <span class="box" v-if="hour">{{ hour }}</span>
            <span v-if="hour">时</span>
            <span class="box">{{ minutes }}</span>
            <span>分</span>
            <span class="box">{{ seconds }}</span>
            <span>秒</span>
          </div>
          <div style="text-align: center" v-if="status != '1'">
            <h2 style="color: #a5a5a5; font-size: 32px">
              <B>竞价已结束</B>
            </h2>
          </div>

          <div style="width: 100%; display: flex; justify-content: center">
            <div class="d-flex r" style="margin: 20px 0">
              <div class="w-100" id="nn">
                <p style="color: #98a2b6">模拟竞价时长：1分钟</p>
                <div>
                  <div></div>
                </div>
              </div>
              <!-- <div class="flex-grow-shrink" id="qq">
                <p style="color: #98a2b6">模拟倒计时阶段(1分钟)</p>
                <div>
                  <div></div>
                </div>
              </div> -->
            </div>
          </div>
          <div v-if="status === '1'" class="text-center" style="color: #bac2d2">
            当前服务器时间 {{ serveDate }}
          </div>
        </div>
        <div>
          <div class="code mt-5">
            <div>
              我的竞价编号为：
              <span style="color: #fff800; font-size: 16px">
                <B>1234</B>
              </span>
            </div>
            <div v-if="status === '1'">
              <span style="margin-right: 5px; color: #98a2b6">
                报价记录实时自动刷新。如遇问题请手动刷新</span
              >
              <a-button
                style="background: #304879 !important"
                size="small"
                ghost
              >
                手动刷新
              </a-button>
            </div>
          </div>
          <div class="table-preant">
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <div class="table-preant-item scrollbar-zdy">
              <table class="table">
                <thead>
                  <tr>
                    <td>竞价人</td>
                    <td>竞价人编号</td>
                    <td>报价</td>
                    <td>报价时间</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(it, index) in data" :key="index">
                    <td>
                      <span v-if="status === '1'">
                        {{ it.supplierName }}
                      </span>
                      <span v-else> {{ it.supplierName2 }}</span>
                    </td>
                    <td>{{ it.competeNo }}</td>
                    <td>
                      <span v-if="status === '1'">
                        {{ it.price2 }}
                      </span>
                      <span v-else>
                        {{ it.price.toLocaleString("en-US") }}</span
                      >
                    </td>
                    <!-- <td>{{ it.price.toLocaleString("en-US") }}</td> -->
                    <td>{{ it.priceDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="zjz_r">
        <div class="title">
          <img :src="$_c + 'img/jjz_img/btn_bg.svg'" />
          <span>报价</span>
        </div>
        <!--竞价说明 -->
        <!-- <BiddingDescription :way="packs.jingjiaWay" /> -->
        <a-divider style="opacity: 0.2" />
        <a-descriptions :column="1" title="竞价方式">
          <a-descriptions-item label="单轮竞价">
            竞高价
            <!--竞价说明 -->
            <BiddingDescription way="2" />
          </a-descriptions-item>
          <a-descriptions-item label="最低限价">
            <span>1000 元</span>
          </a-descriptions-item>
          <a-descriptions-item label="竞价开始时间">
            {{ nowDate }}
          </a-descriptions-item>
          <a-descriptions-item label="竞价时长">
            1 分钟 &nbsp;&nbsp;&nbsp;<span>
              倒计时长
              <span class="color-main">1</span>
              分钟
            </span>
          </a-descriptions-item>
        </a-descriptions>
        <a-divider style="opacity: 0.2" />
        <div class="Operation_area">
          <div class="t1" v-if="status === '1'">
            <span>最低限价：1000 </span>
          </div>
          <div class="t2" v-if="status === '1'">
            <div class="btn">
              <a-icon type="plus" style="color: white" @click="onAdd" />
            </div>

            <a-input-number
              :default-value="3"
              :max="1000000"
              :min="0"
              :step="100"
              v-model="myPrice"
              @keyup.enter.native="submit"
            />

            <div class="btn">
              <a-icon type="minus" style="color: white" @click="onReduce" />
            </div>
          </div>
          <div class="t3" v-if="status === '1'">
            <a-button type="primary" @click="submit"> 提交报价 </a-button>
          </div>
          <div style="text-align: center" v-else>
            <div
              class="text-center mt-5 d-flex justify-content-center align-items-center"
            >
              <a-button type="primary" @click="onRePractice">重新练习</a-button>
            </div>
          </div>
          <div class="t3">
            <a-button class="mr-1" v-if="status === '1'">
              填报详细报价
            </a-button>
            <a-button> 预览详细报价 </a-button>
          </div>
        </div>
        <a-divider style="opacity: 0.2" />
        <!-- <div class="flex-left" v-if="packs.quotationConfirm === '1'">
          <SingleUploadSelector
            :referId="packId + currentSupplierId"
            ref="singleUploadSelector"
            :max="1"
            value="license"
            configKey="supplier_process_confirm"
            @uploadSuccess="uploadSelectorChange"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import CommonHeader from "../common/CommonHeader";
import CommonFooter from "../common/CommonFooter";
import UploadSelector from "@/components/selector/UploadSelector";
import moment from "moment";
import BiddingDescription from "./BiddingDescription.vue";
const columns2 = [
  {
    title: "项目公告",
    scopedSlots: { customRender: "announceName" },
    align: "left",
  },
  {
    title: "发布时间",
    scopedSlots: { customRender: "openTime" },
    align: "right",
  },
];
export default {
  name: "NewSimulationSingleCompete",
  components: {
    CommonHeader,
    CommonFooter,
    UploadSelector,
    moment,
    BiddingDescription,
  },
  watch: {
    projectRandom: {
      immediate: false,
      handler(newValue, oldValue) {},
    },
  },
  created() {
    this.supplierName = this.$ls.get("user").supplierName;
    this.initData();
    this.serverDateTimer = setInterval(this.changeServer, 1000);
    this.countDownTimer = setInterval(this.countDown, 1000);
    this.userName = this.$store.getters.nickname;
  },
  destroyed() {
    clearInterval(this.serverDateTimer);
    clearInterval(this.countDownTimer);
  },
  data() {
    return {
      modal2Visible: false,
      columns2: columns2,
      form: this.$form.createForm(this),
      id: this.$route.query.id,
      currentSupplierId: "",
      project: "",
      strokeWidth: 10,
      announceList: [],
      percent1: 10,
      activeKey: "5",
      competeResultState: "",
      percent2: 10,
      small: "small",
      serveDate: "",
      serverDateTimer: "",
      nowDate: "",
      data: [],
      status: "1",
      prefix: "距离竞价结束还有",
      day: "",
      hour: "",
      minutes: "",
      min: 100000,
      max: 1000000,
      myPrice: "",
      myData: [],
      price: "",
      lastedData: 1000000,
      seconds: "59",
      countDown1: 1000 * 1 * 60,
      countDown2: 1000 * 1 * 60,
      countDownTimer: "",
      userName: "",
      supplierName: "",
    };
  },
  methods: {
    onFresh() {},
    initData() {
      this.data = [];
      this.nowDate = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      var dd = moment(new Date() + 1000).format("YYYY/MM/DD HH:mm:ss");
      this.data.unshift({
        supplierName: "*****",
        supplierName2: "A有限责任公司",
        competeNo: "1235",
        price: 1000000,
        price2: "*****",
        priceDate: dd,
      });
      var dd2 = moment(new Date() + 2000).format("YYYY/MM/DD HH:mm:ss");
      this.data.unshift({
        supplierName: "*****",
        supplierName2: "B有限责任公司",
        competeNo: "1236",
        price2: "*****",
        price: 900000,
        priceDate: dd2,
      });
      this.price = "900000";
    },
    onAdd() {
      if (this.myPrice) {
        this.myPrice = this.myPrice + 1;
      } else {
        this.myPrice = 1;
      }
    },
    onReduce() {
      if (this.myPrice) {
        this.myPrice = this.myPrice - 1;
      } else {
        this.myPrice = 1;
      }
    },
    sysError(content) {
      let secondsToGo = 3;
      const modal = this.$error({
        title: "温馨提示",
        content: content,
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: content,
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
      }, secondsToGo * 1000);
    },
    submit() {
      if (this.myData && this.myData.length > 0) {
        this.sysError("你已提交报价，不可再次报价");
        return;
      }
      var reg = /(^[1-9]\d*$)/;
      var priceNumber = parseInt(this.myPrice);
      if (
        this.myPrice === "" ||
        this.myPrice === null ||
        isNaN(this.myPrice) ||
        priceNumber < 0 ||
        !reg.test(this.myPrice)
      ) {
        // this.$message.error("报价必须为整数值!")
        this.sysError("报价必须为整数值!");
        return;
      }
      if (priceNumber < 1000) {
        this.sysError("必须高于最低限价!");
        return;
      }
      let params = {};
      params.packId = "包组ID";
      params.supplierId = "1234";
      params.supplierName2 = this.supplierName;
      params.supplierName = this.supplierName;
      params.price2 = this.myPrice.toLocaleString("en-US");
      params.price = this.myPrice;
      params.competeNo = "1234";
      params.priceDate = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      this.price = this.myPrice;
      let that = this;
      this.$confirm({
        title: "你的报价为 " + params.price + " 元，你确定要提交吗?",
        okText: "确认提交",
        content: (h) => (
          <div style="color:red;font-size:14px;">
            报价提交后将不可撤回,请谨慎操作!
          </div>
        ),
        onOk() {
          if (that.status === "2") {
            this.sysError("竞价已结束");
          } else {
            // that.myPrice = "";
            that.data.unshift(params);
            that.myData.push(that.myPrice);
          }
        },
        onCancel() {},
      });
    },
    countDown() {
      if (this.countDown1 > 0) {
        this.countDown1 = this.countDown1 - 1000;
        this.prefix = "离竞价结束还有:";
        var date = this.countDown1;
        var days = Math.floor(date / 1000 / 60 / 60 / 24); // 从这里开始
        var daysmod = date - days * 24 * 60 * 60 * 1000;
        var hours = Math.floor(daysmod / 1000 / 60 / 60);
        var hoursmod =
          date - days * 24 * 60 * 60 * 1000 - hours * 1000 * 60 * 60;
        var minutes = Math.floor(hoursmod / 1000 / 60);
        var minutesmod =
          date -
          days * 24 * 60 * 60 * 1000 -
          hours * 1000 * 60 * 60 -
          minutes * 1000 * 60;
        var seconds = Math.floor(minutesmod / 1000); // 到这里结束，是将总毫秒转化成对应天数+小时数+分钟数+秒数的转换方法
        if (hours === 0 && hours === 0) {
          this.day = "";
          this.hour = "";
        } else {
          this.day = days;
          this.hour = hours;
        }
        this.minutes = minutes;
        this.seconds = seconds;
      } else {
        document.getElementById("nn").setAttribute("class", "w-100 no-before");
        this.changeClass();
        this.status = "2";
      }
    },
    changeServer() {
      this.serveDate = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
    },
    changeClass() {
      // document.getElementById('qq')[0].style.color = val
      // document.getElementById('qq')[0].style = 'flex-grow-shrink q'
      // document.getElementById("qq").setAttribute("class", "flex-grow-shrink q");
      document.getElementById("nn").setAttribute("class", "w-100 no-before");
    },
    removeClass() {
      document.getElementById("nn").removeAttribute("class", "w-100 no-before");
      /*  document
        .getElementById("qq")
        .removeAttribute("class", "flex-grow-shrink q"); */
      document.getElementById("nn").setAttribute("class", "w-100");
      // document.getElementById("qq").setAttribute("class", "flex-grow-shrink");
    },
    onClose() {
      // this.visible = true
      this.$confirm({
        title: "提示",
        content: "你确定要关闭当前窗口吗？",
        onOk() {
          window.close();
        },
        onCancel() {},
      });
    },
    onRePractice() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less" scoped>
.zjz_con {
  height: 100vh;
  display: flex;
  overflow: hidden;

  > div {
    height: 100%;
  }

  .zjz_l {
    background: #132957;
    flex: 0 0 auto;
    width: 19.531vw;
    box-shadow: inset -5px 0px 10px 1px rgba(0, 0, 0, 0.2784);
  }

  .zjz_c {
    background: #18336a;
    width: 100%;
    padding: 0.625vw;
    box-sizing: border-box;
    /* 中间的包组信息样式 */
    /deep/ .ant-btn-sm {
      height: 1.25vw;
      padding: 0 0.365vw;
      font-size: 0.729vw;
      border-radius: 0.208vw;
    }
    .t1 {
      padding: 0.521vw;
      width: 100%;
      color: white;
      display: flex;
      justify-content: space-between;
      background: #1d315a;
      border: 0.052vw solid #3c5583;
      margin-bottom: 1.563vw;
      font-size: 0.729vw;
    }

    .t2 {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 1.667vw;

      .box {
        width: 3.229vw;
        height: 2.813vw;
        line-height: 2.813vw;
        text-align: center;
        background: #ebebeb;
        border-radius: 0.208vw;
        color: #000;
        font-size: 1.979vw;
        font-weight: bold;
        box-shadow: inset 0 -1.563vw 0 0 #c8c8c8;
        margin: 0 0.417vw;
      }
    }

    /deep/ .t3 {
      margin-bottom: 0.938vw;

      .ant-progress-inner {
        border-radius: 0;
        overflow: inherit;
      }

      .ant-progress-bg {
        border-radius: 0 !important;
        height: 1.042vw !important;
      }

      .arrow {
        width: 100%;
        max-width: 40.625vw;
        margin: auto;

        .ant-progress-inner {
          background: #e9c376;
        }
      }

      .arrow .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e9c376;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }

      .arrow.red .ant-progress-inner {
        background: #e97a76;
      }
      .arrow.white .ant-progress-inner {
        background: #f5f5f5;
      }
      .countDown {
        position: absolute;
        right: 29.6vw;
      }
      .countDown.red .ant-progress-inner {
        background: #e97a76;
      }
      .countDown.red .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e97a76;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }
      .arrow.red .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e97a76;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }
    }
  }
}

/deep/ .ant-btn {
  height: 2vw;
  padding: 0 0.781vw;
  font-size: 0.729vw;
  line-height: 2vw;
  border: none;
}

.zjz_r {
  background: #132957;
  flex: 0 0 auto;
  width: 19.531vw;
  box-shadow: inset 5px 0 10px 1px rgba(0, 0, 0, 0.2784);
  padding: 0 12px;
  box-sizing: border-box;

  /deep/ .ant-descriptions {
    .ant-descriptions-title {
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 0.417vw;
      font-size: 0.729vw;
    }
    .ant-descriptions-row > td {
      padding-bottom: 0.417vw;
      font-size: 0.729vw;
    }

    .ant-descriptions-item-label {
      color: #fff;
    }

    .ant-descriptions-item-content {
      color: #fff;
    }
  }
  /deep/ .ant-descriptions-item,
  /deep/ .ant-descriptions-item-content {
    display: flex;
    align-items: center;
  }

  /deep/ .file_list {
    a {
      span {
        color: #fff !important;
      }
    }

    small {
      color: rgba(255, 255, 255, 0.5) !important;
    }
  }
}

.Operation_area {
  color: #fff;
  .t1 {
    text-align: center;
  }
  .t2 {
    margin-top: 0.625vw;
    display: flex;
    align-items: center;
    /deep/ .ant-input-number {
      width: 100%;
      border: 0.052vw solid #5e6a84;
      height: 3.646vw;
    }
    /deep/ .ant-input-number-input-wrap {
      height: 100%;
      .ant-input-number-input {
        font-size: 2.083vw;
        text-align: center;
        color: #ff0000;
        background: #0b1d41;
        height: 100%;
      }
    }
    .btn {
      padding: 0 0.625vw;
      flex: 0 0 auto;
      font-weight: bold;
      i {
        font-size: 2.083vw;
      }
    }
  }
  .t3 {
    margin: 0.625vw 0 0 0;
    display: flex;
    padding: 0 2vw;
    .ant-btn {
      flex: 1;
      padding: 0;
    }
  }
}

.ant-divider-horizontal {
  margin: 1.25vw 0;
}

.title {
  position: relative;

  img {
    display: block;
    margin: auto;
    width: 15.417vw;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: 1.146vw;
    color: #fff;
    font-size: 1.458vw;
    font-weight: bold;
  }
}

.back-list {
  margin: 0;
  padding: 0.625vw;

  li {
    padding: 0 0.625vw;
    margin-bottom: 0.417vw;
    min-height: 2.604vw;
    display: flex;
    align-items: center;
    background: linear-gradient(90deg, #18336a 0%, rgba(24, 51, 106, 0) 100%);

    &.pack-title-active {
      background: linear-gradient(90deg, #0084ff 0%, rgba(0, 132, 255, 0) 100%);
    }

    &.pack-title {
      cursor: pointer;
    }

    span {
      font-size: 0.938vw;
      color: #ffffff;
      font-weight: bold;
      text-shadow: 0 0.156vw 0 rgba(0, 0, 0, 0.2784);
    }
  }
}

.flex-left {
  padding: 0 10px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

/* 我的竞价编号 */
.code {
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.table-preant {
  width: 100%;
  border: 0.052vw solid #687996;
  background: #132955;
  position: relative;
  height: calc(100vh - 18vw);
  .img {
    position: absolute;
    width: 1.458vw;
    height: 1.458vw;
    &:nth-child(1) {
      left: 0;
      top: 0;
    }
    &:nth-child(2) {
      right: 0;
      top: 0;
      transform: rotate(90deg);
    }
    &:nth-child(3) {
      left: 0;
      bottom: 0;
      transform: rotate(270deg);
    }
    &:nth-child(4) {
      right: 0;
      bottom: 0;
      transform: rotate(180deg);
    }
  }
  .table-preant-item {
    display: flex;
    justify-content: center;
    .table {
      width: 95%;
      color: white;
      .me {
        background: #e97a76;
        border-radius: 0.26vw;
        padding: 0.26vw;
        margin-right: 0.26vw;
      }
      td {
        font-weight: 500;
        margin-bottom: 0.26vw;
        padding: 0.521vw 0;
        text-align: center;
        border-top: 0.208vw solid #132955;
        border-bottom: 0.208vw solid #132955;
        &:nth-child(1) {
          width: 37%;
          text-align: left;
          padding-left: 0.521vw;
        }
        &:nth-child(2) {
          width: 10.417vw;
          text-align: center;
        }
        &:nth-child(3) {
          width: 10.417vw;
          text-align: center;
        }
        &:nth-last-child(1) {
          text-align: right;
          padding-right: 0.521vw;
        }
      }
      thead td {
        color: white;
        padding: 0.521vw 0.781vw;
        border: none;
      }
      tbody {
        tr {
          background: #425477;
        }
        tr:nth-child(1) td {
          background: #60aa46;
        }
      }
    }
  }
}

.d-flex.r {
  width: 100%;
  max-width: 40.625vw;
}
/*                  后一段                     */
.d-flex.r .flex-grow-shrink {
  width: 200px;
}

.d-flex.r .flex-grow-shrink > div {
  width: 100%;
  background: #e97a76;
  height: 20px;
}
.d-flex.r .flex-grow-shrink.q > div div {
  width: 100%;
  background: #f5f5f5;
  height: 100%;
  animation: myfirst 60s linear;
  -moz-animation: myfirst 60s linear;
  -webkit-animation: myfirst 60s linear;
  -o-animation: myfirst 60s linear;
  position: relative;
}

.d-flex.r .flex-grow-shrink.q > div div::before {
  content: "";
  border-top: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #e97a76;
  border-left: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  right: -10px;
  top: 10px;
}
.d-flex.r .w-100 > div div::before {
  content: "";
  border-top: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #e9c376;
  border-left: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  right: -10px;
  top: 10px;
}
.d-flex.r .w-100 > div {
  width: 100%;
  background: #e9c376;
  height: 20px;
}
.d-flex.r .w-100 > div div {
  width: 100%;
  background: #f5f5f5;
  height: 100%;
  animation: myfirst 60s linear;
  -moz-animation: myfirst 60s linear;
  -webkit-animation: myfirst 60s linear;
  -o-animation: myfirst 60s linear;
  position: relative;
}
.d-flex.r .w-100 > div div::before {
  content: "";
  border-top: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #e9c376;
  border-left: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  right: -10px;
  top: 10px;
}

.d-flex.r .w-100.no-before > div div::before,
.d-flex.r .flex-grow-shrink.no-before > div div::before {
  display: none;
}

@keyframes myfirst {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@-moz-keyframes myfirst /* Firefox */ {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@-webkit-keyframes myfirst /* Safari 和 Chrome */ {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@-o-keyframes myfirst /* Opera */ {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.scrollbar-zdy {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;
  margin-right: -4px;
}

/*-------滚动条整体样式----*/
.scrollbar-zdy::-webkit-scrollbar {
  width: 4px;
}

/*滚动条里面小方块样式*/
.scrollbar-zdy::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.2);
}

/*滚动条里面轨道样式*/
.scrollbar-zdy::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
